export const ROUTES = {
  home: '/',

  academy: '/academy',
  academyKnowledge: '/academy/knowledge',
  academyBooks: '/academy/books',
  academyArticles: '/academy/articles',
  academyGuides: '/academy/guides',
  academyQuotes: '/academy/quotes',
  academyKnowledgeDetail: '/academy/knowledge/:docId',

  market: '/market',
  marketGold: '/market/gold',
  marketStock: '/market/stock',
  marketCenter: '/market/center',
  marketHeatmap: '/market/heatmap',
  marketTools: '/market/tools',
  marketToolsPatternMatch: '/market/tools/pattern-match',
  marketToolsDumpDetective: '/market/tools/dump-detective',
  marketToolsDumpDetectiveReport: '/market/tools/dump-detective/report/:chain/:address',
  marketToolsSupportResistance: '/market/tools/support-resistance',
  marketResearch: '/market/research',
  marketResearchInstitutions: '/market/research/institutions',
  marketResearchFundamentals: '/market/research/fundamentals',

  community: '/community',
  rebate: '/rebate',
  rebateDetail: '/rebate/:exchange',
  admin: '/admin',
  profile: '/profile',
  login: '/login',
  register: '/register',
  forgot: '/forgot',
  bookDetail: '/book/:bookId',
  cryptoDetail: '/crypto/:symbol',
  stockDetail: '/stock/:ticker',
  institutionDetail: '/institution/:cik',

  legacyDocs: '/docs',
  legacyDocsDetail: '/docs/:docId',
  legacyTools: '/tools',
  legacyMarketHeatmap: '/market-heatmap',
  legacyPatternMatch: '/pattern-match',
  legacyDumpDetective: '/dump-detective',
  legacyDumpDetectiveReport: '/dump-detective/report/:chain/:address',
  legacySupportResistance: '/support-resistance',
  legacyInstitutions: '/institutions',
  legacyFundamentals: '/fundamentals',
};
